<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img src="../../assets/images/licai/fanhui.png"/>
			<p class="">新手帮助</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4>(1)注册开户</h4>
				<p class="">您需要填写必要的注册信息，注册成为“富达集团”用户。</p>
				<h4>(2)身份认证</h4>
				<p class="">推出权威身份认证方式，自动核实您的身份。</p>
				<h4>(3)项目投资</h4>
				<p class="">根据自己的要求，选择最合适您的投资项目进行投资。</p>
				<h4>(4)回收本息</h4>
				<p class="">按照项目的具体期限和收益方式，向您的账户进行配发。</p>
				<h4>投资安全</h4>
				<p class="">(1)国际化专业团队富达集团成员由全球专业金融机构、法律行业、经济研究和电子商务等领域的专业人士组成，确保国际专业化水准。</p>
				<p class="">(2)多年综合金融经验公司积累了多年综合金融行业经验，为基金业务开展奠定坚实基础。</p>
				<p class="">(3)多级监管体系第一级：富达集团自身的风险管控体系，凝聚了多年来开展综合金融的行业经验，从制度、流程、系统等方面全方位保护投资者的利益；第二级：政府有关部门严格管理与指导。</p>
				<p class="">(4)多重防护网，防范交易风险富达集团发布的投资服务都会经过公司及专业机构严格的内部审核，同时由 AA 级以上的核心企业提供担保。对一些风险稍大的交易，富达集团还会对项目设立更高的审核标准，确保投资项目的合格性。</p>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "JianglI",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		text-align: center;
	}
</style>
